
import * as MUTATION from '../mutationTypes'
import ajax from '../../http/ajax'
const state = {
    data_list: {},
    floor_list: {},
}

const mutations = {
    [MUTATION.GET_SPECIAL_ACTIVITY_REQUEST] (state, res) {
    },
    [MUTATION.GET_SPECIAL_ACTIVITY_SUCCESS] (state, res) {
        state.data_list = res
    },
    [MUTATION.GET_FLOOR_LIST_REQUEST] (state, res) {
    },
    [MUTATION.GET_FLOOR_LIST_SUCCESS] (state, res) {
        state.floor_list = res
    },
}

export const actions = {
    async getSpecialActivity ({ commit }, params) {
        commit(MUTATION.GET_SPECIAL_ACTIVITY_REQUEST)
        const res = await ajax.get('getSpecialActivity', params)
        commit(MUTATION.GET_SPECIAL_ACTIVITY_SUCCESS, res)
    },
    async getFloorList ({ commit }, params) {
        commit(MUTATION.GET_FLOOR_LIST_REQUEST)
        const res = await ajax.get('getFloorList', params)
        commit(MUTATION.GET_FLOOR_LIST_SUCCESS, res)
    },
}

export default {
    state,
    mutations,
}
